import type {
	CustomItem,
	DropGfgArtworkType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropGfgArtwork = (
	item: Item | CustomItem
): item is DropGfgArtworkType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Drop_GFG_Artwork'
	);
};
